import React, { Component } from 'react';
import gronvindLogo from '../../images/GvmLogoSmall.png';
import {RemoveScrollBar} from 'react-remove-scroll-bar';
import ITOPGraph from './Graph';
import ITOPTable from './ItopTable';
import ConsumerSpeedometer from './GvConsumerSpeedometer';
import GeneratorSpeedometer from './GvGeneratorsSpeedometer';
import Information from './Information';


export default class GvmStats extends Component {
  static propTypes = {

  };

  state = {
      powerGenerators: [],
      isLoaded: false,
      lastReading : []
  }

  componentDidMount() {
    document.title = 'GVM STATS';
  }

render() {

    return (

      <div className="home-gvm-stats">    
             
        <div className="speedometer-card-left">                 
          <GeneratorSpeedometer />
          <p>Gårestrup Vindmøllepark</p>
        </div>
        
         <div className="percentage-display">
         <div className="gronvind-logo">
            <img resizeMode='contain' src={gronvindLogo} alt=""/>
          </div>  
          <Information />
        </div> 

        <div className="speedometer-card-right">      
          <ConsumerSpeedometer/>
          <p>Hjørring by's strømforbrug</p>
        </div>   

        <div className="left-bot-container">          
            <ITOPTable/>        
        </div>        

        <ITOPGraph />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/GvmStats.js